// Central registry of /info/* buying-guide pages (docs/SEO_Page_Instructions.md).
// Used by InfoPage.jsx (the hub listing) and RelatedGuides.jsx (reverse links from
// SSR search pages, docs/ssr-seo-distribution-plan.md Phase 1 item 3) - one source so
// the two can't drift apart. `keywords` are lowercase substrings matched against the
// search term to decide which guides are "related" to a given /search/{slug} page.
const infoGuides = [
  {
    title: 'Melitta Solo & Product Line',
    description:
      'מדריך מקיף על מכונות קפה Melitta Solo, כולל השוואות דגמים, טיפים ומידע על כל הסדרה.',
    path: '/info/melitta-solo',
    lastUpdated: '2026-02-03',
    keywords: ['melitta solo', 'melitta'],
  },
  {
    title: 'Sage Barista Express & Product Line',
    description:
      'מדריך מקיף על מכונת קפה Sage Barista Express, כולל השוואות דגמים, טיפים ומידע על כל הסדרה.',
    path: '/info/sage-barista-express',
    lastUpdated: '2026-02-18',
    keywords: ['sage barista express', 'sage barista', 'barista express'],
  },
  {
    title: 'Sage Bambino Plus & Product Line',
    description:
      'מדריך מקיף על מכונת קפה Sage Bambino Plus, כולל השוואה מול Sage Bambino ו-Barista Express, טיפים ומידע על כל הסדרה.',
    path: '/info/sage-bambino-plus',
    lastUpdated: '2026-10-01',
    keywords: ['sage bambino plus', 'sage bambino', 'bambino plus'],
  },
  {
    title: 'Sage Barista Pro, Touch ו-Oracle Touch',
    description:
      'השוואה בין Sage Barista Pro, Barista Touch, Barista Touch Impress ו-Oracle Touch: מסך, אוטומציה, פורטפילטר ורמת מחיר, והמלצה לפי סגנון ההכנה.',
    path: '/info/sage-barista-pro-touch',
    lastUpdated: '2026-10-16',
    keywords: ['barista pro', 'barista touch', 'barista impress', 'oracle touch', 'oracel touch'],
  },
  {
    title: 'Profitec Go ומכונות Profitec',
    description:
      'מדריך למכונות האספרסו של Profitec: ה-Go הקומפקטית בצבעים השונים, וההבדל מול סדרת Pro 300, 500, 600 ו-700.',
    path: '/info/profitec',
    lastUpdated: '2026-10-16',
    keywords: ['profitec'],
  },
  {
    title: 'Lelit Anna & Product Line',
    description:
      'מדריך מקיף על סדרת מכונות האספרסו Lelit Anna, כולל השוואה בין PL41EM, PL41LEM ו-PL41TEM, טיפים ותחזוקה.',
    path: '/info/lelit-anna',
    lastUpdated: '2026-10-15',
    keywords: ['lelit anna', 'lelit', 'pl41em', 'pl41lem', 'pl41tem'],
  },
];

// Conventions that let one `/info/:slug` route (pages/InfoGuideRoute.jsx) serve every guide:
// a guide at /info/<slug> lives in pages/info/<PascalSlug>Page.jsx and reports the analytics
// page name <Title-Slug>-Page (e.g. sage-bambino-plus -> SageBambinoPlusPage / Sage-Bambino-Plus-Page).
// Adding a guide is therefore a page file + one registry entry above (+ `npm run sitemap`);
// no App.jsx edit.
const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1);

export const INFO_GUIDE_PATH_PREFIX = '/info/';

export const findGuideBySlug = (slug) =>
  infoGuides.find((guide) => guide.path === `${INFO_GUIDE_PATH_PREFIX}${slug}`);

export const slugOfGuide = (guide) => guide.path.slice(INFO_GUIDE_PATH_PREFIX.length);

export const pageComponentNameForSlug = (slug) => `${slug.split('-').map(capitalize).join('')}Page`;

export const pageViewNameForSlug = (slug) => `${slug.split('-').map(capitalize).join('-')}-Page`;

export default infoGuides;
